import React from 'react';
import { SimplifiedTable } from 'features/command-center/components/shared';
import { TABLES_KEYS } from 'features/command-center/constants';
import { SECONDARY_API_CLIENT } from 'services/API';
import {
  ScrollableDataTable,
  ScrollableDataTableLayout
} from 'UI/components/templates/ScrollableDataTableLayout';

import { COLUMNS, ORDER_BY_OPTIONS, VIRTUAL_PROPS } from './JobOrdersDrawerContent.constants';
import { formatResponse } from './JobOrdersDrawerContent.utils';

export const JobOrdersDrawerContent = ({ endpoint = '' }) => {
  return (
    <ScrollableDataTableLayout
      content={
        <SimplifiedTable
          apiInstance={SECONDARY_API_CLIENT}
          columns={COLUMNS}
          endpoint={endpoint}
          formatResponse={formatResponse}
          orderByOptions={ORDER_BY_OPTIONS}
          pageKey={TABLES_KEYS.drawerJobOrders}
          shouldUseSavedPagination={false}
          showWrapper={false}
          virtualProps={VIRTUAL_PROPS}
          TableComponent={ScrollableDataTable}
        />
      }
    />
  );
};
